import React, {useState} from 'react'
import { IoChevronDown } from "react-icons/io5";
import './Singleselect.css'

const Singleselect = ({selectedSocVal, placeholder, socialjs, desginationSelect}) => {
    // console.log(socialjs)
    const [socialvalue, setSocialvalue] = useState("")
    const [social, setSocial] = useState(false)

    const handleSocialFocus = () =>{
        setSocial(!social)
    }
    
    const handleSocialClick = (e, incoming) =>{
        setSocialvalue(incoming.soc)
        setSocial(!social)
        selectedSocVal(incoming.socid)
        desginationSelect(incoming.soc)
    }

    const handleValueChange = (e) =>{
        setSocial(true)
        setSocialvalue(e.target.value)
        // console.log(e.target.value)
    }
    
    // var SocialLists = socialjs.filter((filteredItem) => {
    //     if (filteredItem.name.toLowerCase().includes(socialvalue.toLowerCase())) {
    //       return filteredItem;
    //     }
    // });

    // console.log(SocialLists)

    const handleMouseLeave = () =>{
        setSocial(false)
    }

    var SocialLists = socialjs.filter((filteredItem) => {
        if (filteredItem.name.toLowerCase().includes(socialvalue.toLowerCase())) {
          return filteredItem;
        }
    });

  return (
    <div className='sing-selectt-container'>
        <input value={socialvalue} onClick={handleSocialFocus} placeholder={placeholder} onChange={handleValueChange} id="bnw-dropdown-box"/>
            <IoChevronDown id="chevron-down" onClick={handleSocialFocus}/>
            {social && <div onMouseLeave={handleMouseLeave} className='bnw-regionn-drpdwn'>{SocialLists.sort((a, b) => a.name > b.name ? 1 : -1).map((item, key) => (
                <span onClick={e => handleSocialClick(e, {soc: item.name, socid: item.ID})} key={key}>{item.name}</span>
            ))}
            </div>}
    </div>
  )
}

export default Singleselect